'use client'

/**
 * What the side navigation shows while `AppSidebarHost` resolves (#15618).
 *
 * A real (empty) sai-ui `Sidebar`, not `null`: the sidebar's in-flow gap
 * element is what pushes the application pane right, so a `null` fallback
 * would lay the page out full-width and then shove it 224px sideways when the
 * host resolved. The skeleton holds the same gap, collapsed or not.
 */

import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarHeader,
} from '@sai/ui/components'

import { SIDEBAR_FIXED_PLACEMENT_CLASS } from '@/components/app-sidebar/sidebar-placement'
import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

const PLACEHOLDER_ROWS = 8

export function AppSidebarSkeleton() {
  return (
    <Sidebar
      ariaLabel="App Primary Nav"
      ariaDescription="Loading navigation"
      collapsible="icon"
      // The resolved sidebar's placement, so loading neither sits under the
      // banners nor stops short of the viewport bottom (#16342).
      className={cn(
        SIDEBAR_FIXED_PLACEMENT_CLASS,
        'border-e border-stroke-light',
      )}
      aria-busy="true"
    >
      <SidebarHeader className="h-16">
        <Skeleton className="h-6 w-28" />
      </SidebarHeader>
      <SidebarContent className="justify-start">
        <SidebarGroup className="gap-2">
          {Array.from({ length: PLACEHOLDER_ROWS }, (_, index) => (
            <Skeleton key={index} className="h-10 w-full" />
          ))}
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  )
}
